import { defineStore } from 'pinia';
import type { IKeyAny, IKeyString, ILoader } from '@coreInterfaces/interface';

export const useAppStore = defineStore('app-store', {
    state: () => {
        return {
            copyright: '' as string,
            currencies: {
                aud: 'AUD',
                cny: 'CNY',
                hkd: 'HKD',
                idr: 'IDR',
                myr: 'MYR',
                sgd: 'SGD',
                thb: 'THB',
                twd: 'TWD',
                usd: 'USD',
                vnd: 'VND'
            } as IKeyString,
            envAttrs: {} as IKeyString,
            i18n: {} as IKeyAny,
            isLoaded: false as boolean,
            isLoading: false as boolean,
            loader: {
                isActive: false,
                images: {
                    src: '../images/loader/loader.svg',
                    alt: 'loader'
                }
            } as ILoader,
            locales: ['cn', 'en'] as Array<string>,
            types: [] as Array<string>
        };
    },

    getters: {
        getCopyright: (state) => (): string => {
            return state.copyright;
        },

        getCurrencies: (state) => (): IKeyString => {
            return state.currencies;
        },

        getEnvAttrs: (state) => (): Object => {
            return state.envAttrs;
        },

        getEnvAttrsByKey:
            (state) =>
            (key: string): string => {
                return state.envAttrs[key];
            },

        getJSONVersion: (state) => (): string => {
            return 'VITE_APP_VERSION' in state.envAttrs ? `?v=${state.envAttrs['VITE_APP_VERSION']}` : '';
        },

        getLoader: (state) => (): ILoader => {
            return state.loader;
        },

        getLoaderStatus: (state) => (): boolean => {
            return state.loader.isActive;
        },

        getLoading: (state) => (): boolean => {
            return state.isLoading;
        },

        getLocales: (state) => (): Array<string> => {
            return state.locales;
        },

        getText:
            (state) =>
            (key: string, type?: string): string => {
                switch (type) {
                    case 'object':
                        return state.i18n.tm(key);
                    default:
                        return state.i18n.t(key);
                }
            },

        getTypes: (state) => (): Array<string> => {
            return state.types;
        }
    },

    actions: {
        setCopyright(copyright: string): void {
            this.copyright = copyright;
        },

        setCurrencies(currencies: IKeyString): void {
            this.currencies = currencies;
        },

        setEnvAttrs(attributes: Object): void {
            this.envAttrs = attributes as IKeyString;
        },

        setIsLoaded(isLoaded: boolean): void {
            this.isLoaded = isLoaded;
        },

        setLoading(isLoading: boolean): void {
            this.isLoading = isLoading;
        },

        setI18n(i18n: any): void {
            this.i18n = i18n;
        },

        setTypes(types: Array<string>): void {
            this.types = types;
        },

        toggleLoader(isShow: boolean): void {
            let store = this;

            if (isShow) {
                store.loader.isActive = isShow;
            } else {
                // setTimeout(function () {
                store.loader.isActive = isShow;
                // }, 500);
            }
        }
    }
});
